module.exports = __webpack_public_path__ + "static/media/10.13290950.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/10.png
// module id = 1292
// module chunks = 0